// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1wrZu","footer":"ModalCreateQualiphyProcedure_footer__1LU0c","additionData":"ModalCreateQualiphyProcedure_additionData__252yU"};